import React, { useState } from "react";
import ReactModal from "react-modal";
import style from "../SendMerchantLink/SendMerchantLink.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import { changeSignerEmail } from "../../../../../api";
import toast from "react-hot-toast";
import CloseIcon16 from "../../../../assets/svg/icons/common/CloseIcon16";
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function EditEmail({ open, onClose, appData, fetchApplication = null }) {
  const [email, setEmail] = useState(appData?.otp_email ? appData.otp_email : "");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setEmail(value);
    if (validateEmail(value)) {
      setError("");
    } else {
      setError("Invalid phone number");
    }
  };

  const updateOTPEmail = async () => {
    const payload = {
      email: email,
      editslug: appData?.editslug,
      id: appData?.id
    };

    setIsLoading(true);
    setError("");
    const toastId = toast.loading("Updating email...");
    let response;
    try {
      response = await changeSignerEmail(payload);
    } catch (error) {
      // A retention refusal comes back as a 403, which rejects the promise; without
      // this the loading toast never resolves and the modal stays locked.
      const message =
        error?.response?.data?.message || "Something went wrong!";
      toast.error(message, { id: toastId });
      setIsLoading(false);
      setError(message);
      return;
    }

    if (response.status) {
      toast.success("OTP mobile updated successfully!", { id: toastId });
      if (typeof fetchApplication === 'function') {
        fetchApplication();
      }
      onClose();
    } else {
      toast.error("Something went wrong!", { id: toastId });
      setIsLoading(false);
      setError('Something went wrong!');
    }
  }

  return (
    <ReactModal isOpen={open} className={style.react_modal}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <CloseIcon16 />
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Edit Email</h6>

        <div className={style.form_group}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            id="email"
            className={style.input_select}
            value={email}
            onChange={handleChange}
          />
          {error && (
            <span className={style.error} >{error}</span>
          )}
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            isLoading={isLoading}
            disabled={error}
            onClick={() => updateOTPEmail()}
          >
            Send
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default EditEmail;
